/**
 * egye palinka izek
 */
export type FruitSpiritOtherFlavor =
  | 'BANANA'
  | 'ORANGE'
  | 'PERSIMMON'
  | 'HAWTHORN'
  | 'CHESTNUT'
  | 'OTHER';

export const FruitSpiritOtherFlavor = {
  Banana: 'BANANA' as FruitSpiritOtherFlavor,
  Orange: 'ORANGE' as FruitSpiritOtherFlavor,
  Persimmon: 'PERSIMMON' as FruitSpiritOtherFlavor,
  Hawthorn: 'HAWTHORN' as FruitSpiritOtherFlavor,
  Chestnut: 'CHESTNUT' as FruitSpiritOtherFlavor,
  Other: 'OTHER' as FruitSpiritOtherFlavor,
};
